import { useState, useEffect, useCallback } from 'react';
import { get, post, put } from '../api';

function Btn({ onClick, children, variant='primary', small, disabled, style={} }) {
  const s={primary:{background:'#c9a96e',color:'#1a1208',border:'none'},secondary:{background:'transparent',color:'#8a7055',border:'1px solid #3a2a12'},danger:{background:'#e63c3c22',color:'#e63c3c',border:'1px solid #e63c3c44'},success:{background:'#10b98122',color:'#10b981',border:'1px solid #10b98144'},ghost:{background:'#c9a96e18',color:'#c9a96e',border:'1px solid #c9a96e44'}};
  return <button onClick={onClick} disabled={disabled} style={{...s[variant],borderRadius:8,padding:small?'6px 14px':'10px 22px',fontWeight:700,cursor:disabled?'default':'pointer',fontSize:small?12:14,opacity:disabled?0.5:1,fontFamily:'inherit',...style}}>{children}</button>;
}
function Input({ label, value, onChange, placeholder, type='text', rows }) {
  const s={width:'100%',background:'#2a1f0f',border:'1px solid #3a2a12',borderRadius:8,padding:'10px 14px',color:'#f5e6c8',fontSize:14,boxSizing:'border-box',fontFamily:'inherit'};
  return (<div style={{marginBottom:14}}>{label&&<label style={{display:'block',color:'#8a7055',fontSize:11,marginBottom:6,textTransform:'uppercase',letterSpacing:'0.06em'}}>{label}</label>}{rows?<textarea value={value} onChange={onChange} placeholder={placeholder} rows={rows} style={{...s,resize:'vertical'}}/>:<input type={type} value={value} onChange={onChange} placeholder={placeholder} style={s}/>}</div>);
}
function Modal({ children, onClose, wide }) {
  return (<div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:20}} onClick={onClose}><div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:14,padding:32,maxWidth:wide?860:660,width:'100%',maxHeight:'90vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>{children}</div></div>);
}

// ── Leaderboard ───────────────────────────────────────────────────────────────
export function LeaderboardView({ currentUserId }) {
  const [board, setBoard] = useState([]);
  const [myBadges, setMyBadges] = useState([]);
  const [tab, setTab] = useState('board');
  const load = useCallback(async () => {
    const [b, mb] = await Promise.all([get('/leaderboard'), get('/badges/my')]);
    setBoard(b); setMyBadges(mb);
    // Auto-check for new badges
    try { await post('/badges/check', {}); } catch(e) {}
  }, []);
  useEffect(() => { load(); }, [load]);

  const medals = ['🥇','🥈','🥉'];

  return (
    <div>
      <h2 style={{fontFamily:"'Playfair Display', serif",fontSize:26,color:'#f5e6c8',marginBottom:8}}>Leaderboard</h2>
      <p style={{color:'#8a7055',marginBottom:24}}>Complete training to climb the ranks and earn badges</p>

      <div style={{display:'flex',gap:4,marginBottom:24,borderBottom:'1px solid #3a2a12'}}>
        {[{k:'board',l:'Rankings'},{k:'badges',l:`My Badges (${myBadges.length})`}].map(t=>(
          <button key={t.k} onClick={()=>setTab(t.k)} style={{background:'none',border:'none',borderBottom:tab===t.k?'2px solid #c9a96e':'2px solid transparent',color:tab===t.k?'#c9a96e':'#8a7055',padding:'8px 16px',cursor:'pointer',fontWeight:tab===t.k?700:400,fontSize:13,fontFamily:'inherit'}}>{t.l}</button>
        ))}
      </div>

      {tab === 'board' && (
        <div style={{display:'grid',gap:10}}>
          {board.map((u,i) => {
            const isMe = u.id === currentUserId;
            return (
              <div key={u.id} style={{background:isMe?'#c9a96e18':'#1a1208',border:`1px solid ${isMe?'#c9a96e44':'#3a2a12'}`,borderRadius:12,padding:'16px 20px',display:'flex',alignItems:'center',gap:14}}>
                <div style={{width:36,height:36,borderRadius:'50%',background:i<3?'#c9a96e22':'#2a1f0f',display:'flex',alignItems:'center',justifyContent:'center',fontSize:i<3?22:16,flexShrink:0}}>
                  {i<3?medals[i]:`#${i+1}`}
                </div>
                <div style={{flex:1}}>
                  <div style={{color:'#f5e6c8',fontWeight:700,fontSize:15}}>{u.name} {isMe&&<span style={{color:'#c9a96e',fontSize:12}}>(you)</span>}</div>
                  <div style={{color:'#5a4030',fontSize:12}}>{u.position} · {u.badges} badge{u.badges!==1?'s':''}</div>
                </div>
                <div style={{textAlign:'right'}}>
                  <div style={{color:'#c9a96e',fontWeight:700,fontSize:20}}>{u.pct}%</div>
                  <div style={{color:'#5a4030',fontSize:11}}>{u.certs} certified</div>
                </div>
              </div>
            );
          })}
          {board.length === 0 && <p style={{color:'#5a4030',textAlign:'center',padding:40}}>No staff on the leaderboard yet.</p>}
        </div>
      )}

      {tab === 'badges' && (
        <div>
          {myBadges.length === 0 && <div style={{textAlign:'center',padding:'40px 0'}}><div style={{fontSize:48,marginBottom:16}}>🎯</div><p style={{color:'#8a7055'}}>No badges yet. Complete training modules to earn your first badge!</p></div>}
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:16}}>
            {myBadges.map(b=>(
              <div key={b.id} style={{background:'#1a1208',border:`1px solid ${b.color}44`,borderRadius:12,padding:20,textAlign:'center'}}>
                <div style={{fontSize:40,marginBottom:8}}>{b.icon}</div>
                <div style={{fontFamily:"'Playfair Display', serif",color:b.color,fontSize:16,fontWeight:700,marginBottom:4}}>{b.title}</div>
                <div style={{color:'#8a7055',fontSize:12}}>{b.description}</div>
                <div style={{color:'#5a4030',fontSize:11,marginTop:8}}>Earned {new Date(b.earned_at).toLocaleDateString()}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Quick Reference ───────────────────────────────────────────────────────────
export function QuickReferenceView() {
  const [refs, setRefs] = useState([]);
  const [customCards, setCustomCards] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');
  useEffect(() => {
    get('/quickref').then(setRefs).catch(()=>{});
    get('/quickref/custom').then(setCustomCards).catch(()=>{});
  }, []);

  const allCards = [
    ...refs.map(r => ({ id: r.id, title: r.title, category: r.category, content: r.quick_ref })),
    ...customCards.map(c => ({ id: c.id, title: c.title, category: c.category, content: c.content }))
  ];
  const filtered = allCards.filter(r => r.title.toLowerCase().includes(search.toLowerCase()) || r.content.toLowerCase().includes(search.toLowerCase()) || r.category.toLowerCase().includes(search.toLowerCase()));
  const catColor = { Foundation:'#c9a96e', Operations:'#f59e0b', Activity:'#e63c3c', Safety:'#10b981', Systems:'#6366f1', Bar:'#a855f7', Kitchen:'#f97316' };

  return (
    <div>
      <h2 style={{fontFamily:"'Playfair Display', serif",fontSize:26,color:'#f5e6c8',marginBottom:8}}>Quick Reference</h2>
      <p style={{color:'#8a7055',marginBottom:20}}>Fast access to scripts, rules, and key info for your shift</p>
      <div style={{marginBottom:20}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search quick reference..." style={{width:'100%',background:'#1a1208',border:'1px solid #3a2a12',borderRadius:10,padding:'12px 16px',color:'#f5e6c8',fontSize:14,boxSizing:'border-box',fontFamily:'inherit'}} />
      </div>
      {selected && (
        <div style={{background:'#1a1208',border:`1px solid ${catColor[selected.category]||'#3a2a12'}44`,borderRadius:12,padding:24,marginBottom:20}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:16}}>
            <h3 style={{fontFamily:"'Playfair Display', serif",color:'#f5e6c8',fontSize:20}}>{selected.title}</h3>
            <button onClick={()=>setSelected(null)} style={{background:'none',border:'none',color:'#8a7055',cursor:'pointer',fontSize:20}}>×</button>
          </div>
          <pre style={{color:'#d4b896',fontSize:14,lineHeight:1.7,whiteSpace:'pre-wrap',fontFamily:'inherit',margin:0}}>{selected.content}</pre>
        </div>
      )}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(250px,1fr))',gap:14}}>
        {filtered.map(r=>(
          <div key={r.id} onClick={()=>setSelected(selected?.id===r.id?null:r)} style={{background:'#1a1208',border:`1px solid ${selected?.id===r.id?catColor[r.category]||'#c9a96e':'#3a2a12'}`,borderRadius:10,padding:18,cursor:'pointer',borderLeft:`4px solid ${catColor[r.category]||'#c9a96e'}`,transition:'all 0.15s'}}>
            <div style={{color:catColor[r.category]||'#c9a96e',fontSize:10,textTransform:'uppercase',letterSpacing:'0.08em',fontWeight:700,marginBottom:6}}>{r.category}</div>
            <div style={{fontFamily:"'Playfair Display', serif",color:'#f5e6c8',fontSize:16,marginBottom:6}}>{r.title}</div>
            <div style={{color:'#8a7055',fontSize:12}}>Tap to view quick reference</div>
          </div>
        ))}
        {filtered.length===0 && <p style={{color:'#5a4030',gridColumn:'1/-1',textAlign:'center',padding:40}}>No quick reference cards found.</p>}
      </div>
    </div>
  );
}

// ── Branding Settings ─────────────────────────────────────────────────────────
export function BrandingSettings() {
  const [branding, setBranding] = useState({ logo_url:'', primary_color:'#c9a96e', accent_color:'#10b981', background_color:'#0a0702', sidebar_color:'#0f0a05', welcome_message:'Welcome to Tee & Timber Training Hub', platform_name:'Tee & Timber Training Hub', owner_email:'', smtp_user:'', smtp_pass:'', smtp_host:'smtp.office365.com', smtp_port:'587' });
  const [emailTestMsg, setEmailTestMsg] = useState('');
  const [logoMsg, setLogoMsg] = useState('');

  // Convert an uploaded image to a resized base64 string and store it in logo_url.
  function handleLogoFile(file) {
    if (!file.type.startsWith('image/')) { setLogoMsg('Please choose an image file (PNG or JPG).'); return; }
    setLogoMsg('Processing image...');
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        // Resize so the longest side is at most 400px — keeps the stored logo small.
        const maxSize = 400;
        let { width, height } = img;
        if (width > height && width > maxSize) { height = Math.round(height * maxSize / width); width = maxSize; }
        else if (height > maxSize) { width = Math.round(width * maxSize / height); height = maxSize; }
        const canvas = document.createElement('canvas');
        canvas.width = width; canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL('image/png');
        if (dataUrl.length > 1500000) { setLogoMsg('That image is too large even after resizing. Try a smaller or simpler image.'); return; }
        setBranding(p => ({ ...p, logo_url: dataUrl }));
        setLogoMsg('✓ Logo loaded! Click "Save All Settings" below to apply it.');
      };
      img.onerror = () => setLogoMsg('Could not read that image. Try a different file.');
      img.src = ev.target.result;
    };
    reader.onerror = () => setLogoMsg('Could not read that file.');
    reader.readAsDataURL(file);
  }
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => { get('/branding').then(b=>{ if(b?.id) setBranding(b); setLoading(false); }).catch(()=>setLoading(false)); }, []);

  async function save() {
    await put('/branding', branding);
    setSaved(true); setTimeout(()=>setSaved(false), 2000);
  }

  if (loading) return <p style={{color:'#5a4030',textAlign:'center',padding:40}}>Loading...</p>;

  return (
    <div>
      <h2 style={{fontFamily:"'Playfair Display', serif",fontSize:26,color:'#f5e6c8',marginBottom:8}}>Branding & Settings</h2>
      <p style={{color:'#8a7055',marginBottom:24}}>Customize how the platform looks and feels for your team</p>

      <div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:12,padding:24,marginBottom:20}}>
        <h3 style={{color:'#c9a96e',marginBottom:16,fontWeight:700}}>Platform Identity</h3>
        <Input label="Platform Name" value={branding.platform_name} onChange={e=>setBranding(p=>({...p,platform_name:e.target.value}))} placeholder="Tee & Timber Training Hub" />
        <Input label="Welcome Message (shown on login screen)" value={branding.welcome_message} onChange={e=>setBranding(p=>({...p,welcome_message:e.target.value}))} placeholder="Welcome to the Tee & Timber Training Hub..." rows={2} />
        <div style={{marginBottom:14}}>
          <label style={{display:'block',color:'#8a7055',fontSize:11,marginBottom:6,textTransform:'uppercase',letterSpacing:'0.06em'}}>Logo — Upload an Image</label>
          <div
            onDragOver={e=>{e.preventDefault();e.currentTarget.style.borderColor='#c9a96e';e.currentTarget.style.background='#c9a96e10';}}
            onDragLeave={e=>{e.currentTarget.style.borderColor='#3a2a12';e.currentTarget.style.background='#2a1f0f';}}
            onDrop={e=>{
              e.preventDefault();
              e.currentTarget.style.borderColor='#3a2a12';
              e.currentTarget.style.background='#2a1f0f';
              const file = e.dataTransfer.files[0];
              if (file) handleLogoFile(file);
            }}
            onClick={()=>document.getElementById('logo-file-input').click()}
            style={{border:'2px dashed #3a2a12',borderRadius:10,padding:'24px',textAlign:'center',cursor:'pointer',background:'#2a1f0f',transition:'all 0.15s'}}
          >
            <div style={{fontSize:28,marginBottom:6}}>🖼️</div>
            <div style={{color:'#c9a96e',fontSize:13,fontWeight:700,marginBottom:2}}>Drag an image here, or click to browse</div>
            <div style={{color:'#5a4030',fontSize:11}}>PNG or JPG · small file recommended (under 1MB)</div>
            <input id="logo-file-input" type="file" accept="image/png,image/jpeg,image/jpg,image/webp" style={{display:'none'}} onChange={e=>{const f=e.target.files[0]; if(f) handleLogoFile(f);}} />
          </div>
          {logoMsg && <p style={{color:logoMsg.startsWith('✓')?'#10b981':'#e63c3c',fontSize:12,marginTop:8}}>{logoMsg}</p>}
        </div>
        <Input label="...or paste a Logo URL instead" value={branding.logo_url.startsWith('data:') ? '' : branding.logo_url} onChange={e=>setBranding(p=>({...p,logo_url:e.target.value}))} placeholder="https://..." />
        {branding.logo_url && <div style={{background:'#2a1f0f',borderRadius:8,padding:16,marginTop:-8,marginBottom:14}}><div style={{color:'#5a4030',fontSize:11,marginBottom:8}}>Current logo preview:</div><img src={branding.logo_url} alt="Logo preview" style={{maxHeight:80,maxWidth:'100%',objectFit:'contain'}} onError={e=>{e.target.style.display='none'}} /></div>}
      </div>

      <div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:12,padding:24,marginBottom:20}}>
        <h3 style={{color:'#c9a96e',marginBottom:16,fontWeight:700}}>Color Scheme</h3>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:16}}>
          {[
            {l:'Primary Color (buttons, accents)',k:'primary_color'},
            {l:'Accent Color (success, highlights)',k:'accent_color'},
            {l:'Background Color',k:'background_color'},
            {l:'Sidebar Color',k:'sidebar_color'},
          ].map(f=>(
            <div key={f.k}>
              <label style={{display:'block',color:'#8a7055',fontSize:11,marginBottom:8,textTransform:'uppercase',letterSpacing:'0.06em'}}>{f.l}</label>
              <div style={{display:'flex',gap:10,alignItems:'center'}}>
                <input type="color" value={branding[f.k]} onChange={e=>setBranding(p=>({...p,[f.k]:e.target.value}))} style={{width:44,height:44,borderRadius:8,border:'1px solid #3a2a12',background:'#2a1f0f',cursor:'pointer',padding:2}} />
                <input value={branding[f.k]} onChange={e=>setBranding(p=>({...p,[f.k]:e.target.value}))} style={{flex:1,background:'#2a1f0f',border:'1px solid #3a2a12',borderRadius:8,padding:'10px 12px',color:'#f5e6c8',fontSize:13,fontFamily:'monospace'}} />
              </div>
            </div>
          ))}
        </div>
        <div style={{marginTop:16,padding:16,borderRadius:10,background:branding.background_color,border:'1px solid #3a2a12'}}>
          <div style={{color:'#8a7055',fontSize:11,marginBottom:8,textTransform:'uppercase',letterSpacing:'0.06em'}}>Preview</div>
          <div style={{display:'flex',gap:10}}>
            <div style={{background:branding.primary_color,color:'#1a1208',padding:'8px 16px',borderRadius:8,fontWeight:700,fontSize:13}}>Primary Button</div>
            <div style={{background:branding.accent_color+'22',color:branding.accent_color,border:`1px solid ${branding.accent_color}44`,padding:'8px 16px',borderRadius:8,fontWeight:700,fontSize:13}}>Accent</div>
          </div>
        </div>
        <div style={{marginTop:12}}>
          <button onClick={()=>setBranding(p=>({...p,primary_color:'#c9a96e',accent_color:'#10b981',background_color:'#0a0702',sidebar_color:'#0f0a05'}))} style={{background:'none',border:'1px dashed #3a2a12',borderRadius:8,color:'#8a7055',padding:'6px 14px',cursor:'pointer',fontSize:12,fontFamily:'inherit'}}>↩ Reset to Tee & Timber defaults</button>
        </div>
      </div>

      <div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:12,padding:24,marginBottom:24}}>
        <h3 style={{color:'#c9a96e',marginBottom:12,fontWeight:700}}>📹 Video Upload Guide</h3>
        <div style={{color:'#d4b896',fontSize:14,lineHeight:1.8}}>
          <p style={{marginBottom:12}}>To add training videos, host them externally and paste the embed link:</p>
          <div style={{background:'#2a1f0f',borderRadius:8,padding:16,marginBottom:12}}>
            <div style={{color:'#c9a96e',fontWeight:700,marginBottom:8}}>YouTube (Recommended — Free)</div>
            <ol style={{paddingLeft:18,margin:0,color:'#d4b896',fontSize:13}}>
              <li style={{marginBottom:4}}>Upload your video to YouTube.com</li>
              <li style={{marginBottom:4}}>Click <strong style={{color:'#f5e6c8'}}>Share → Embed</strong></li>
              <li style={{marginBottom:4}}>Copy ONLY the URL inside <code style={{background:'#1a1208',padding:'1px 4px',borderRadius:3}}>src="..."</code></li>
              <li style={{marginBottom:4}}>Example: <code style={{background:'#1a1208',padding:'1px 4px',borderRadius:3,fontSize:11}}>https://www.youtube.com/embed/VIDEO_ID</code></li>
              <li>Set video to <strong style={{color:'#f5e6c8'}}>Unlisted</strong> so only people with the link can see it</li>
            </ol>
          </div>
          <div style={{background:'#2a1f0f',borderRadius:8,padding:16,marginBottom:12}}>
            <div style={{color:'#6366f1',fontWeight:700,marginBottom:8}}>Vimeo (More Professional — Optional)</div>
            <ol style={{paddingLeft:18,margin:0,color:'#d4b896',fontSize:13}}>
              <li style={{marginBottom:4}}>Upload to Vimeo.com (free plan available)</li>
              <li style={{marginBottom:4}}>Click <strong style={{color:'#f5e6c8'}}>Share → Embed → copy the src URL</strong></li>
              <li>Example: <code style={{background:'#1a1208',padding:'1px 4px',borderRadius:3,fontSize:11}}>https://player.vimeo.com/video/VIDEO_ID</code></li>
            </ol>
          </div>
          <div style={{background:'#2a1f0f',borderRadius:8,padding:16}}>
            <div style={{color:'#f59e0b',fontWeight:700,marginBottom:8}}>Then add to your platform:</div>
            <ol style={{paddingLeft:18,margin:0,color:'#d4b896',fontSize:13}}>
              <li style={{marginBottom:4}}>Go to <strong style={{color:'#f5e6c8'}}>Content Editor</strong> in the sidebar</li>
              <li style={{marginBottom:4}}>Select the module you want to add the video to</li>
              <li style={{marginBottom:4}}>Click <strong style={{color:'#f5e6c8'}}>+ Add Video</strong></li>
              <li>Paste the embed URL and click Add Video</li>
            </ol>
          </div>
        </div>
      </div>

      <div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:12,padding:24,marginBottom:24}}>
        <h3 style={{color:'#c9a96e',marginBottom:8,fontWeight:700}}>📧 Email Notifications</h3>
        <p style={{color:'#8a7055',fontSize:13,marginBottom:16}}>Get emailed when temperatures go out of range or checklists are completed. Uses your Microsoft 365 or email account.</p>
        <Input label="Owner Email (where alerts are sent)" value={branding.owner_email} onChange={e=>setBranding(p=>({...p,owner_email:e.target.value}))} placeholder="kevin@teeandtimber.com" />
        <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:14}}>
          <Input label="Sending Email Address (SMTP user)" value={branding.smtp_user} onChange={e=>setBranding(p=>({...p,smtp_user:e.target.value}))} placeholder="notifications@teeandtimber.com" />
          <Input label="Email Password / App Password" type="password" value={branding.smtp_pass} onChange={e=>setBranding(p=>({...p,smtp_pass:e.target.value}))} placeholder="••••••••" />
        </div>
        <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:14}}>
          <Input label="SMTP Host" value={branding.smtp_host} onChange={e=>setBranding(p=>({...p,smtp_host:e.target.value}))} placeholder="smtp.office365.com" />
          <Input label="SMTP Port" value={branding.smtp_port} onChange={e=>setBranding(p=>({...p,smtp_port:e.target.value}))} placeholder="587" />
        </div>
        <div style={{background:'#2a1f0f',borderRadius:8,padding:14,marginBottom:14}}>
          <div style={{color:'#8a7055',fontSize:12,lineHeight:1.6}}>
            <strong style={{color:'#c9a96e'}}>Microsoft 365 / Outlook:</strong> Host: smtp.office365.com, Port: 587<br/>
            <strong style={{color:'#c9a96e'}}>Gmail:</strong> Host: smtp.gmail.com, Port: 587 (requires an App Password, not your regular password)<br/>
            <strong style={{color:'#f59e0b'}}>Tip:</strong> For security, create a dedicated email like notifications@teeandtimber.com rather than using your personal login.
          </div>
        </div>
        <div style={{display:'flex',gap:10,alignItems:'center'}}>
          <Btn variant="ghost" small onClick={async()=>{
            await put('/branding', branding);
            try { await post('/notifications/test', {}); setEmailTestMsg('✓ Test email sent! Check your inbox.'); }
            catch(e){ setEmailTestMsg('Error: ' + e.message); }
          }}>Send Test Email</Btn>
          {emailTestMsg && <span style={{color:emailTestMsg.startsWith('✓')?'#10b981':'#e63c3c',fontSize:13}}>{emailTestMsg}</span>}
        </div>
      </div>

      {saved && <div style={{background:'#10b98118',border:'1px solid #10b98144',borderRadius:8,padding:12,marginBottom:16,color:'#10b981',fontWeight:700}}>✓ Settings saved!</div>}
      <Btn onClick={save}>Save All Settings</Btn>
    </div>
  );
}

// ── Staff Profiles (Manager view) ─────────────────────────────────────────────
export function StaffProfilesView({ users, onRefresh }) {
  const [selected, setSelected] = useState(null);
  const [notes, setNotes] = useState([]);
  const [noteForm, setNoteForm] = useState({ note:'', note_type:'general' });
  const [editForm, setEditForm] = useState({});
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  const staff = (users||[]).filter(u=>u.role==='staff');

  async function loadNotes(userId) {
    try { setNotes(await get(`/notes/${userId}`)); } catch(e) { setNotes([]); }
  }

  async function selectUser(u) {
    setSelected(u);
    setEditForm({
      hire_date:u.hire_date||'', position:u.position||'',
      food_handler_cert:u.food_handler_cert||'', food_handler_expiry:u.food_handler_expiry||'',
      harassment_cert:u.harassment_cert||'', harassment_expiry:u.harassment_expiry||'',
      rbs_number:u.rbs_number||'', rbs_expiry:u.rbs_expiry||''
    });
    await loadNotes(u.id);
  }

  // Shrink an uploaded cert photo to max 1500px and store as base64 (keeps it legible but small)
  function handleCertUpload(file, field) {
    if (!file) return;
    if (!file.type.startsWith('image/')) { alert('Please upload a photo (JPG or PNG) of the certificate.'); return; }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        const maxSize = 1500;
        let { width, height } = img;
        if (width > height && width > maxSize) { height = Math.round(height * maxSize / width); width = maxSize; }
        else if (height > maxSize) { width = Math.round(width * maxSize / height); height = maxSize; }
        const canvas = document.createElement('canvas');
        canvas.width = width; canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.85);
        if (dataUrl.length > 4000000) { alert('That image is still too large. Try a clearer but smaller photo.'); return; }
        setEditForm(p => ({ ...p, [field]: dataUrl }));
      };
      img.onerror = () => alert('Could not read that image.');
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }

  // Validity periods (must match the Compliance Tracker): Food Handler 2yr, Harassment 2yr, RBS 3yr
  const CERT_VALIDITY_YEARS = { food_handler: 2, harassment: 2, rbs: 3 };

  // Given an issue date and a cert key, auto-fill the matching expiry field
  function setIssueDate(certKey, issueDateStr) {
    const years = CERT_VALIDITY_YEARS[certKey];
    let expiry = '';
    if (issueDateStr && years) {
      const d = new Date(issueDateStr);
      d.setFullYear(d.getFullYear() + years);
      expiry = d.toISOString().slice(0, 10); // YYYY-MM-DD
    }
    setEditForm(p => ({ ...p, [`${certKey}_issue`]: issueDateStr, [`${certKey}_expiry`]: expiry }));
  }

  async function saveProfile() {
    setLoading(true);
    try { await put(`/profiles/${selected.id}`, editForm); setEditing(false); onRefresh(); await selectUser({ ...selected, ...editForm }); }
    catch(e) { alert(e.message); } finally { setLoading(false); }
  }

  async function addNote() {
    if (!noteForm.note) return;
    await post(`/notes/${selected.id}`, noteForm);
    setNoteForm({ note:'', note_type:'general' });
    await loadNotes(selected.id);
  }

  const noteTypeColor = { general:'#c9a96e', performance:'#10b981', concern:'#e63c3c', commendation:'#6366f1' };

  if (selected) return (
    <div>
      <button onClick={()=>{setSelected(null);setEditing(false);}} style={{background:'none',border:'none',color:'#8a7055',cursor:'pointer',fontSize:13,marginBottom:20,fontFamily:'inherit'}}>← Back to Staff</button>
      <div style={{display:'flex',alignItems:'center',gap:16,marginBottom:24}}>
        <div style={{width:56,height:56,borderRadius:'50%',background:'#c9a96e',color:'#1a1208',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Playfair Display', serif",fontWeight:700,fontSize:20}}>{selected.name.split(' ').map(w=>w[0]).join('').slice(0,2)}</div>
        <div>
          <h2 style={{fontFamily:"'Playfair Display', serif",fontSize:24,color:'#f5e6c8',marginBottom:2}}>{selected.name}</h2>
          <div style={{color:'#8a7055',fontSize:13}}>@{selected.username} · {selected.position||'No position'}</div>
        </div>
        <Btn small variant="ghost" onClick={()=>setEditing(!editing)} style={{marginLeft:'auto'}}>{editing?'Cancel':'✏️ Edit Profile'}</Btn>
      </div>

      {editing ? (
        <div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:12,padding:24,marginBottom:20}}>
          <h4 style={{color:'#c9a96e',marginBottom:16}}>Edit Profile</h4>
          <Input label="Position / Job Title" value={editForm.position} onChange={e=>setEditForm(p=>({...p,position:e.target.value}))} placeholder="e.g. Axe Coach" />
          <Input label="Hire Date" type="date" value={editForm.hire_date} onChange={e=>setEditForm(p=>({...p,hire_date:e.target.value}))} />

          <div style={{borderTop:'1px solid #3a2a12',marginTop:8,paddingTop:16}}>
            <div style={{color:'#c9a96e',fontSize:13,fontWeight:700,marginBottom:14}}>📄 Certifications</div>

            {/* Food Handler */}
            <div style={{background:'#2a1f0f',borderRadius:8,padding:14,marginBottom:12}}>
              <div style={{color:'#f5e6c8',fontSize:13,fontWeight:600,marginBottom:8}}>Food Handler Card {editForm.food_handler_cert ? '✓' : '(required)'}</div>
              <input type="file" accept="image/png,image/jpeg,image/jpg" onChange={e=>handleCertUpload(e.target.files[0],'food_handler_cert')} style={{color:'#8a7055',fontSize:12,marginBottom:8,width:'100%'}} />
              {editForm.food_handler_cert && <div style={{marginBottom:8}}><img src={editForm.food_handler_cert} alt="Food Handler cert" style={{maxHeight:120,maxWidth:'100%',borderRadius:6,border:'1px solid #3a2a12'}} /></div>}
              <Input label="Issue Date (expiry auto-calculates — valid 2 years)" type="date" value={editForm.food_handler_issue || ''} onChange={e=>setIssueDate('food_handler', e.target.value)} />
              <Input label="Expiry Date (auto-filled — override if needed)" type="date" value={editForm.food_handler_expiry} onChange={e=>setEditForm(p=>({...p,food_handler_expiry:e.target.value}))} />
            </div>

            {/* Harassment */}
            <div style={{background:'#2a1f0f',borderRadius:8,padding:14,marginBottom:12}}>
              <div style={{color:'#f5e6c8',fontSize:13,fontWeight:600,marginBottom:8}}>Sexual Harassment Training Cert {editForm.harassment_cert ? '✓' : '(required)'}</div>
              <input type="file" accept="image/png,image/jpeg,image/jpg" onChange={e=>handleCertUpload(e.target.files[0],'harassment_cert')} style={{color:'#8a7055',fontSize:12,marginBottom:8,width:'100%'}} />
              {editForm.harassment_cert && <div style={{marginBottom:8}}><img src={editForm.harassment_cert} alt="Harassment cert" style={{maxHeight:120,maxWidth:'100%',borderRadius:6,border:'1px solid #3a2a12'}} /></div>}
              <Input label="Issue Date (expiry auto-calculates — valid 2 years)" type="date" value={editForm.harassment_issue || ''} onChange={e=>setIssueDate('harassment', e.target.value)} />
              <Input label="Expiry Date (auto-filled — override if needed)" type="date" value={editForm.harassment_expiry} onChange={e=>setEditForm(p=>({...p,harassment_expiry:e.target.value}))} />
            </div>

            {/* RBS */}
            <div style={{background:'#2a1f0f',borderRadius:8,padding:14,marginBottom:4}}>
              <div style={{color:'#f5e6c8',fontSize:13,fontWeight:600,marginBottom:8}}>RBS (Alcohol Server) — not required for kitchen</div>
              <Input label="RBS Number" value={editForm.rbs_number} onChange={e=>setEditForm(p=>({...p,rbs_number:e.target.value}))} placeholder="RBS certificate number" />
              <Input label="RBS Issue Date (expiry auto-calculates — valid 3 years)" type="date" value={editForm.rbs_issue || ''} onChange={e=>setIssueDate('rbs', e.target.value)} />
              <Input label="RBS Expiry Date (auto-filled — override if needed)" type="date" value={editForm.rbs_expiry} onChange={e=>setEditForm(p=>({...p,rbs_expiry:e.target.value}))} />
            </div>
          </div>

          <div style={{display:'flex',gap:10,marginTop:14}}><Btn onClick={saveProfile} disabled={loading}>Save</Btn><Btn variant="secondary" onClick={()=>setEditing(false)}>Cancel</Btn></div>
        </div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:24}}>
          {[{l:'Hire Date',v:selected.hire_date?new Date(selected.hire_date).toLocaleDateString():'Not set'},{l:'Account Created',v:new Date(selected.created_at).toLocaleDateString()}].map(i=>(
            <div key={i.l} style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:8,padding:'12px 16px'}}>
              <div style={{color:'#8a7055',fontSize:11,textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:4}}>{i.l}</div>
              <div style={{color:'#f5e6c8',fontSize:14}}>{i.v}</div>
            </div>
          ))}
        </div>
      )}

      {!editing && (
        <div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:12,padding:24,marginBottom:20}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16,flexWrap:'wrap',gap:10}}>
            <h4 style={{color:'#c9a96e',margin:0}}>📄 Certifications</h4>
            <a href={`/api/profiles/${selected.id}/certs-pdf?token=${localStorage.getItem('tnt_token')}`} target="_blank" rel="noreferrer" style={{background:'#6366f122',color:'#6366f1',border:'1px solid #6366f144',borderRadius:8,padding:'8px 14px',textDecoration:'none',fontSize:12,fontWeight:700}}>📑 Export Certs PDF</a>
          </div>
          {[
            {label:'Food Handler Card', img:selected.food_handler_cert, exp:selected.food_handler_expiry},
            {label:'Sexual Harassment Training', img:selected.harassment_cert, exp:selected.harassment_expiry},
          ].map(c => {
            const expSoon = c.exp && (new Date(c.exp) - new Date()) < 1000*60*60*24*30;
            const expired = c.exp && new Date(c.exp) < new Date();
            return (
              <div key={c.label} style={{background:'#2a1f0f',borderRadius:8,padding:14,marginBottom:10}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:c.img?8:0,flexWrap:'wrap',gap:6}}>
                  <span style={{color:'#f5e6c8',fontSize:13,fontWeight:600}}>{c.label} {c.img ? '✓ on file' : '— not uploaded'}</span>
                  {c.exp && <span style={{color: expired ? '#e63c3c' : expSoon ? '#f59e0b' : '#10b981',fontSize:12,fontWeight:700}}>
                    {expired ? 'EXPIRED' : expSoon ? 'Expiring soon' : 'Valid'} · {new Date(c.exp).toLocaleDateString()}
                  </span>}
                </div>
                {c.img && <a href={c.img} target="_blank" rel="noreferrer"><img src={c.img} alt={c.label} style={{maxHeight:140,maxWidth:'100%',borderRadius:6,border:'1px solid #3a2a12'}} /></a>}
              </div>
            );
          })}
          <div style={{background:'#2a1f0f',borderRadius:8,padding:14}}>
            <span style={{color:'#f5e6c8',fontSize:13,fontWeight:600}}>RBS Number: </span>
            <span style={{color: selected.rbs_number ? '#10b981' : '#8a7055',fontSize:13}}>{selected.rbs_number || 'Not provided (n/a for kitchen)'}</span>
            {selected.rbs_expiry && <span style={{color:'#8a7055',fontSize:12}}> · expires {new Date(selected.rbs_expiry).toLocaleDateString()}</span>}
          </div>
        </div>
      )}
      <div style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:12,padding:24}}>
        <h4 style={{color:'#c9a96e',marginBottom:16}}>🔒 Manager Notes (Private — Staff cannot see these)</h4>
        <div style={{marginBottom:16}}>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:12}}>
            {[{v:'general',l:'General'},{v:'performance',l:'Performance'},{v:'commendation',l:'👍 Commendation'},{v:'concern',l:'⚠️ Concern'}].map(o=>(
              <div key={o.v} onClick={()=>setNoteForm(p=>({...p,note_type:o.v}))} style={{padding:'6px 10px',borderRadius:8,cursor:'pointer',border:`1px solid ${noteForm.note_type===o.v?noteTypeColor[o.v]:'#3a2a12'}`,background:noteForm.note_type===o.v?noteTypeColor[o.v]+'18':'#2a1f0f',color:noteForm.note_type===o.v?noteTypeColor[o.v]:'#8a7055',textAlign:'center',fontSize:12}}>{o.l}</div>
            ))}
          </div>
          <textarea value={noteForm.note} onChange={e=>setNoteForm(p=>({...p,note:e.target.value}))} placeholder="Add a private note about this staff member..." rows={3} style={{width:'100%',background:'#2a1f0f',border:'1px solid #3a2a12',borderRadius:8,padding:'10px 14px',color:'#f5e6c8',fontSize:14,boxSizing:'border-box',fontFamily:'inherit',resize:'vertical',marginBottom:10}} />
          <Btn small onClick={addNote} disabled={!noteForm.note}>Add Note</Btn>
        </div>
        <div style={{display:'grid',gap:8}}>
          {notes.map(n=>(
            <div key={n.id} style={{background:'#2a1f0f',borderRadius:8,padding:'12px 14px',borderLeft:`3px solid ${noteTypeColor[n.note_type]||'#c9a96e'}`}}>
              <div style={{color:noteTypeColor[n.note_type]||'#c9a96e',fontSize:10,textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:4}}>{n.note_type} · {n.author}</div>
              <div style={{color:'#d4b896',fontSize:13}}>{n.note}</div>
              <div style={{color:'#5a4030',fontSize:11,marginTop:4}}>{new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
          {notes.length===0 && <p style={{color:'#5a4030',fontSize:13}}>No notes yet.</p>}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <h2 style={{fontFamily:"'Playfair Display', serif",fontSize:26,color:'#f5e6c8',marginBottom:24}}>Staff Profiles</h2>
      <div style={{display:'grid',gap:12}}>
        {staff.map(u=>(
          <div key={u.id} onClick={()=>selectUser(u)} style={{background:'#1a1208',border:'1px solid #3a2a12',borderRadius:10,padding:'16px 20px',display:'flex',alignItems:'center',gap:14,cursor:'pointer',transition:'border-color 0.15s'}}
            onMouseEnter={e=>e.currentTarget.style.borderColor='#c9a96e44'}
            onMouseLeave={e=>e.currentTarget.style.borderColor='#3a2a12'}>
            <div style={{width:40,height:40,borderRadius:'50%',background:'#c9a96e',color:'#1a1208',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Playfair Display', serif",fontWeight:700,fontSize:14,flexShrink:0}}>{u.name.split(' ').map(w=>w[0]).join('').slice(0,2)}</div>
            <div style={{flex:1}}>
              <div style={{color:'#f5e6c8',fontWeight:600}}>{u.name}</div>
              <div style={{color:'#5a4030',fontSize:12}}>{u.position||'No position'} · Joined {new Date(u.created_at).toLocaleDateString()}</div>
            </div>
            <span style={{color:'#8a7055',fontSize:16}}>›</span>
          </div>
        ))}
        {staff.length===0 && <p style={{color:'#5a4030',textAlign:'center',padding:40}}>No staff yet. Add staff in the Users panel.</p>}
      </div>
    </div>
  );
}

// ── First Day Welcome ─────────────────────────────────────────────────────────
export function FirstDayWelcome({ user, branding, onDismiss }) {
  return (
    <div style={{minHeight:'100vh',background:'#0a0702',display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div style={{background:'#1a1208',border:'1px solid #c9a96e44',borderRadius:16,padding:'48px 40px',maxWidth:560,width:'100%',textAlign:'center',boxShadow:'0 24px 80px rgba(0,0,0,0.6)'}}>
        {branding?.logo_url ? <img src={branding.logo_url} alt="Logo" style={{maxHeight:80,maxWidth:'100%',objectFit:'contain',marginBottom:20}} /> : <div style={{fontSize:52,marginBottom:16}}>🪓</div>}
        <h1 style={{fontFamily:"'Playfair Display', serif",fontSize:28,color:'#f5e6c8',marginBottom:8}}>Welcome, {user.name}!</h1>
        <p style={{color:'#c9a96e',fontSize:14,marginBottom:24,lineHeight:1.6}}>{branding?.welcome_message||'Welcome to the Tee & Timber Training Hub'}</p>
        <div style={{background:'#2a1f0f',borderRadius:10,padding:20,marginBottom:24,textAlign:'left'}}>
          <div style={{color:'#c9a96e',fontWeight:700,marginBottom:12}}>🗓 Your First Week at a Glance</div>
          {[{d:'Day 1',t:'Orientation & Hospitality Training'},{d:'Day 2',t:'Front Desk & Reservations'},{d:'Day 3',t:'Axe Throwing Safety & Coaching'},{d:'Day 4',t:'Lucky Putt & Krazy Darts'},{d:'Day 5',t:'Opening, Closing & Final Certification'}].map(item=>(
            <div key={item.d} style={{display:'flex',gap:10,marginBottom:8}}>
              <span style={{color:'#c9a96e',fontWeight:700,fontSize:13,flexShrink:0,minWidth:40}}>{item.d}</span>
              <span style={{color:'#d4b896',fontSize:13}}>{item.t}</span>
            </div>
          ))}
        </div>
        <div style={{background:'#10b98118',border:'1px solid #10b98144',borderRadius:10,padding:16,marginBottom:24,textAlign:'left'}}>
          <div style={{color:'#10b981',fontWeight:700,marginBottom:8}}>✓ Start Here</div>
          <div style={{color:'#d4b896',fontSize:13}}>1. Go to <strong style={{color:'#f5e6c8'}}>Sign-Offs</strong> and sign your acknowledgment documents<br/>2. Go to <strong style={{color:'#f5e6c8'}}>Onboarding</strong> to see your Day 1 checklist<br/>3. Go to <strong style={{color:'#f5e6c8'}}>Training</strong> to start Module 1</div>
        </div>
        <p style={{color:'#8a7055',fontSize:12,marginBottom:20}}>Questions? Ask your manager. We're glad to have you on the team. 🙌</p>
        <Btn onClick={onDismiss} style={{width:'100%'}}>Let's Get Started →</Btn>
      </div>
    </div>
  );
}
